module.exports = __webpack_public_path__ + "static/media/thumbnail.b77ab9b4.jpg";